export class AwpDmsInterfaceConfig {
  isAwpDmsInterfaceEnabled: boolean = false;
}
